import {
	createDefaultVideoListItem,
	getVideoListCoverUrl,
	getVideoListVideoUrl,
	normalizeVideoListData,
} from './videoList.js';
import {
	getPayMediaUnlockKey,
	isPayMediaUnlocked,
	normalizePayMediaPriceFields,
	setPayMediaUnlocked,
} from './payMediaCommon.js';
import { img, video } from './localAssets.js';

export const PAY_VIDEO_SERIES_TYPE = 'pay-video-series';
const UNLOCK_PREFIX = 'pay-video-series';
export const PAY_VIDEO_SERIES_COMPACT_FREE_COUNT = 1;
export const PAY_VIDEO_SERIES_COMPACT_MAX_ITEMS = 4;

const SERIES_ITEM_PRESETS = [
	{ id: 'dv-13001', title: '荒原来信', description: '购买后观看', duration: 242, filesize: '82 MB', filesize_byte: Math.round(82 * 1024 * 1024), videoUrl: 'pay-video-series-1.mp4', coverUrl: 'pay-video-series-1.png' },
	{ id: 'dv-13002', title: '失落禁区', description: '购买后观看', duration: 322, filesize: '109 MB', filesize_byte: Math.round(109 * 1024 * 1024), videoUrl: 'pay-video-series-2.mp4', coverUrl: 'pay-video-series-2.png' },
	{ id: 'dv-13003', title: '巨兽苏醒', description: '购买后观看', duration: 346, filesize: '117 MB', filesize_byte: Math.round(117 * 1024 * 1024), videoUrl: 'pay-video-series-3.mp4', coverUrl: 'pay-video-series-3.png' },
	{ id: 'dv-13004', title: '最后的协议', description: '购买后观看', duration: 315, filesize: '131 MB', filesize_byte: Math.round(131 * 1024 * 1024), videoUrl: 'pay-video-series-4.mp4', coverUrl: 'pay-video-series-4.png' },
];

export function createDefaultPayVideoSeriesItems(count = 4) {
	const items = [];
	for (let i = 0; i < count; i += 1) {
		items.push(createDefaultVideoListItem(SERIES_ITEM_PRESETS[i] || SERIES_ITEM_PRESETS[0], i));
	}
	return items;
}

export function getPayVideoSeriesDefaults(extra = {}) {
	return normalizePayVideoSeriesData({
		items: createDefaultPayVideoSeriesItems(4),
		title: '荒原协议',
		subtitle: '4集 · 科幻 · AI影像',
		description: '公元2179年，人类在荒原深处截获了一段不属于地球的信号。沉睡百年的战争机器再次苏醒，失落的机械文明开始重返地表。',
		payDesc: '一次购买 · 永久观看',
		price: '29.90',
		buttonText: '立即解锁',
		freePreviewCount: 1,
		...extra,
	});
}

export function normalizePayVideoSeriesData(data = {}) {
	const base = normalizeVideoListData(data);
	const payFields = normalizePayMediaPriceFields(data, {
		defaultPrice: '29.90',
		defaultButtonText: '立即解锁',
		maxPreviewCount: base.items.length,
	});
	return {
		...base,
		...payFields,
		title: data.title || '荒原协议',
		subtitle: data.subtitle || `${base.items.length}集 · 科幻 · AI影像`,
		description: data.description || '公元2179年，人类在荒原深处截获了一段信号。沉睡百年的战争机器再次苏醒，失落的机械文明开始重返地表。',
		payDesc: data.payDesc || '一次购买 · 永久观看',
	};
}

export function isPayVideoSeriesBlock(type) {
	return type === PAY_VIDEO_SERIES_TYPE;
}

export {
	getVideoListCoverUrl,
	getVideoListVideoUrl,
};

export function getPayVideoSeriesUnlockKey(blockId) {
	return getPayMediaUnlockKey(blockId, UNLOCK_PREFIX);
}

export function isPayVideoSeriesUnlocked(blockId) {
	return isPayMediaUnlocked(blockId, UNLOCK_PREFIX);
}

export function setPayVideoSeriesUnlocked(blockId, unlocked = true) {
	setPayMediaUnlocked(blockId, UNLOCK_PREFIX, unlocked);
}

export function getPayVideoSeriesListEntries(data = {}, { unlocked = false, compact = false } = {}) {
	const normalized = normalizePayVideoSeriesData(data);
	const pageCount = normalized.items.length;
	const freeCount = compact
		? Math.min(PAY_VIDEO_SERIES_COMPACT_FREE_COUNT, normalized.freePreviewCount, pageCount)
		: normalized.freePreviewCount;
	const displayItems = compact
		? normalized.items.slice(0, PAY_VIDEO_SERIES_COMPACT_MAX_ITEMS)
		: normalized.items;

	return displayItems.map((item, index) => ({
		key: item.id,
		item,
		index,
		locked: unlocked ? false : index >= freeCount,
	}));
}

export function getPayVideoSeriesPreviewDefaults() {
	return normalizePayVideoSeriesData({
		items: createDefaultPayVideoSeriesItems(4),
		freePreviewCount: 1,
	});
}

export function formatEpisodeIndex(index = 0) {
	const num = Number(index) + 1;
	return String(num).padStart(2, '0');
}
